import React from 'react'

export type CountryData = {
  selectedCountry: string
}

export const SelectedCountryContext = React.createContext<CountryData>({
  selectedCountry: '',
})
